exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".deprecated {\r\n    font-style: italic;\r\n    color: #7f8fa4;\r\n}\r\n", ""]);

// exports
